import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/merchant/auth',
    method: 'post',
    data: {
      identifier: username,
      password: password
    }
  })
}

export function loginUser(username, password) {
  return request({
    url: '/auth/local',
    method: 'post',
    data: {
      identifier: username,
      password: password
    }
  })
}

export function signUpUser(email, password) {
  return request({
    url: '/auth/local/register',
    method: 'post',
    data: {
      email: email,
      password: password
    }
  })
}

export function getInfo() {
  return request({
    url: '/user/me',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

export function forgotPassword(data) {
  return request({
    url: '/auth/forgot-password',
    method: 'post',
    data
  })
}

export function resetPassword(data) {
  return request({
    url: '/auth/reset-password',
    method: 'post',
    data
  })
}

export function changePassword(data) {
  return request({
    url: '/auth/change-password',
    method: 'post',
    data
  })
}

export function emailConfirm(params) {
  return request({
    url: '/auth/email-confirmation',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js